<div class="card">
<p-table
  #dt
  [value]="orders"
  [paginator]="true"
  [rows]="pageSize"
  [totalRecords]="totalRecords"
  [lazy]="true"
  (onPage)="onPage($event)"
  [showCurrentPageReport]="true"
  [tableStyle]="{ 'min-width': '65rem' }"
  [rowsPerPageOptions]="[5,10,20]"
  (onSort)="onSort($event)"
  dataKey="id"
  [globalFilterFields]="['id','userId','productId','status','user.userDetails.userName']"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} orders"
  styleClass="p-datatable-lg"
  [expandedRowKeys]="expandedRows"
  [rowHover]="true"
  [paginatorDropdownAppendTo]="'body'"
>
  <ng-template pTemplate="caption">
    <div class="flex justify-content-between align-items-center">
      <div class="flex align-items-center">
        <span class="mr-2">Digital Business Card Orders</span>
      </div>
      <div class="flex align-items-center gap-2">
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input id="globalSearchInput" pInputText type="text" (input)="applyGlobalFilter($event)" placeholder="Search" />
        </span>
        <!-- Order ID Filter -->
        <span>
          <input id="orderIdFilterInput" pInputText type="text" [(ngModel)]="filters.orderId" placeholder="Order ID" class="filter-field" (keyup.enter)="applyFilters()" />
        </span>
        <!-- User Filter (username contains) -->
        <span>
          <input id="userFilterInput" pInputText type="text" [(ngModel)]="filters.user" placeholder="User" class="filter-field" (keyup.enter)="applyFilters()" />
        </span>
        <!-- Status Filter -->
        <span>
          <p-dropdown id="statusFilterDropdown" [options]="statusOptions" [(ngModel)]="filters.status" placeholder="Status" styleClass="filter-field" (onChange)="applyFilters()"></p-dropdown>
        </span>
        <button id="applyFiltersButton" pButton type="button" icon="pi pi-filter" label="Filter" class="p-button-sm p-button-outlined" (click)="applyFilters()"></button>
        <!-- <button pButton type="button" icon="pi pi-times" class="p-button-text p-button-danger p-button-sm" (click)="resetFilters()" *ngIf="hasActiveFilters()"></button> -->
        <button id="refreshOrdersButton" pButton type="button" icon="pi pi-refresh" class="p-button-text" (click)="refreshOrders(true)" [disabled]="loading"></button>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr class="sticky-header">
      <th style="width: 3rem"></th>
      <th style="width: 10%" id="orderIdHeader" pSortableColumn="id">Order ID</th>
      <th style="width: 15%" id="userHeader" pSortableColumn="userId">User</th>
      <th style="width: 15%" id="productHeader" pSortableColumn="productId">Product</th>
      <th style="width: 8%" id="quantityHeader" pSortableColumn="quantity">Qty</th>
      <th style="width: 10%" id="totalAmountHeader" pSortableColumn="totalAmount">Total</th>
      <th style="width: 20%" id="statusHeader" pSortableColumn="status">Status</th>
      <th style="width: 15%" id="createdDateHeader" pSortableColumn="createdDate">Created</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-order let-expanded="expanded">
    <tr class="fade-in">
      <td (click)="toggleRowExpansion(order)">
        <button id="expandRowButton_{{order?.id}}" type="button" pButton pRipple [pRowToggler]="order" class="p-button-text p-button-rounded p-button-plain"
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" (click)="toggleRowExpansion(order)"></button>
      </td>
      <td>{{ order?.id }}</td>
      <td>{{ order?.user?.userDetails?.userName }}</td>
      <td>{{ order?.product?.name }}</td>
      <td>{{ order?.quantity }}</td>
      <td>{{ order?.totalAmount | currency }}</td>
      <td>
        <p-dropdown
          id="statusDropdown_{{order?.id}}"
          [options]="statusOptions"
          [(ngModel)]="order.status"
          [disabled]="order.updating"
          (onChange)="onStatusChange(order, $event.value)"
          styleClass="w-full"
          placeholder="Select Status"
        >
          <ng-template pTemplate="selectedItem" let-value>
            <span class="flex align-items-center gap-2">
              <i *ngIf="order.updating" class="pi pi-spin pi-spinner text-600"></i>
              <p-tag *ngIf="value" [value]="value" [severity]="statusSeverity(value)"></p-tag>
              <span *ngIf="!value && !order.updating">N/A</span>
            </span>
          </ng-template>
          <ng-template let-option pTemplate="item">
            <p-tag [value]="option" [severity]="statusSeverity(option)"></p-tag>
          </ng-template>
        </p-dropdown>
      </td>
      <td>{{ order?.createdDate | date:'short' }}</td>
    </tr>
  </ng-template>

  <ng-template pTemplate="rowexpansion" let-order>
    <tr>
      <td colspan="8">
        <div class="grid p-3" style="background:#f9fafb;border-radius:6px;">
          <div class="col-12 md:col-4">
            <h4 class="mt-0 mb-2">Design Files</h4>
            <div *ngIf="order.frontDesign || order.backDesign; else noDesign" class="design-files flex gap-3">
              <div class="design-preview" *ngIf="order.frontDesign">
                <a id="frontDesignLink_{{order?.id}}" [href]="order.frontDesign.fileUrl" target="_blank" rel="noopener" class="preview-link">
                  <ng-container *ngIf="isImage(order?.frontDesign.fileUrl); else frontLinkFallback">
                    <img [src]="order.frontDesign.fileUrl" alt="Front design" loading="lazy" (error)="onImageError($event)" />
                  </ng-container>
                  <ng-template #frontLinkFallback>
                    <span class="file-fallback pi pi-file"></span>
                  </ng-template>
                  <span class="label">Front</span>
                </a>
              </div>
              <div class="design-preview" *ngIf="order.backDesign">
                <a id="backDesignLink_{{order?.id}}" [href]="order.backDesign.fileUrl" target="_blank" rel="noopener" class="preview-link">
                  <ng-container *ngIf="isImage(order?.backDesign.fileUrl); else backLinkFallback">
                    <img [src]="order.backDesign.fileUrl" alt="Back design" loading="lazy" (error)="onImageError($event)" />
                  </ng-container>
                  <ng-template #backLinkFallback>
                    <span class="file-fallback pi pi-file"></span>
                  </ng-template>
                  <span class="label">Back</span>
                </a>
              </div>
            </div>
            <ng-template #noDesign><span class="text-600">No design files uploaded</span></ng-template>
          </div>
          <div class="col-12 md:col-4">
            <h4 class="mt-0 mb-2">QR</h4>
            <div *ngIf="getOrderQr(order); else noQr" class="design-files flex gap-3">
      <div class="design-preview qr-preview">
                <a id="qrCodeLink_{{order?.id}}"
                   [href]="getOrderQr(order)"
                   target="_blank"
                   rel="noopener"
                   class="preview-link"
                   pTooltip="Open QR in new tab">
                  <ng-container *ngIf="isImage(getOrderQr(order)); else qrFallback">
        <img [src]="getOrderQr(order)"
         class="qr-image"
         alt="QR Code"
         loading="lazy"
         (error)="onImageError($event)" />
                  </ng-container>
                  <ng-template #qrFallback>
                    <span class="file-fallback pi pi-qrcode"></span>
                  </ng-template>
                  <span class="label">QR</span>
                </a>
                <div class="mt-2 flex gap-2">
                  <button id="downloadQrBtn_{{order?.id}}"
                          type="button"
                          pButton
                          icon="pi pi-download"
                          class="p-button-text p-button-sm"
                          (click)="downloadQr(order)"
                          pTooltip="Download QR Code"></button>
                  <button *ngIf="isImage(getOrderQr(order))"
                          id="openQrBtn_{{order?.id}}"
                          type="button"
                          pButton
                          icon="pi pi-external-link"
                          class="p-button-text p-button-sm"
                          (click)="openQrInNewTab(order)"
                          pTooltip="Open in new tab"></button>
                </div>
              </div>
            </div>
            <ng-template #noQr><span class="text-600">No QR generated/uploaded</span></ng-template>
          </div>
          <div class="col-12 md:col-4">
              <div class="card">
                    <h4 class="mt-0 mb-2">Shipping Address</h4>
                    <ul class="list-none p-0 m-0" *ngIf="order?.address; else noAddress">
                        <li class="p-1 mb-1 flex items-center justify-between rounded  text-indigo-900">
                            <div class="flex items-center">
                            <span class="text-lg font-medium">State: </span></div><span class="text-lg font-bold">{{ order.address?.state }}</span>
                        </li>
                        <li class="p-1 mb-1 flex items-center justify-between rounded  text-indigo-900">
                            <div class="flex items-center">
                            <span class="text-lg font-medium">City: </span></div><span class="text-lg font-bold">{{ order.address?.city }}</span>
                        </li>
                        <li class="p-1 mb-1 flex items-center justify-between rounded  text-indigo-900">
                            <div class="flex items-center">
                            <span class="text-lg font-medium">Street: </span></div><span class="text-lg font-bold">{{ order.address?.street }}</span>
                        </li>
                        <li class="p-1 mb-1 flex items-center justify-between rounded  text-indigo-900">
                            <div class="flex items-center">
                            <span class="text-lg font-medium">Street 1: </span></div><span class="text-lg font-bold">{{ order.address?.street1 }}</span>
                        </li>
                        <li class="p-1 mb-1 flex items-center justify-between rounded  text-indigo-900">
                            <div class="flex items-center">
                            <span class="text-lg font-medium">ZIP: </span></div><span class="text-lg font-bold">{{ order.address?.zip }}</span>
                        </li>
                    </ul>
                    <ng-template #noAddress><span class="text-600">No address</span></ng-template>
            </div>
          </div>
        </div>
      </td>
    </tr>
  </ng-template>

<ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="9" class="text-center text-gray-400">
        <div class="mt-3">
          <div *ngIf="loading; else noData">
            Loading users...
          </div>
          <ng-template #noData>
            No users found
          </ng-template>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
</div>
